import { render, staticRenderFns } from "./VoyagePlanActivities.vue?vue&type=template&id=db3abd84&"
import script from "./VoyagePlanActivities.vue?vue&type=script&lang=js&"
export * from "./VoyagePlanActivities.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports